export enum MailgunEventTypeEnum {
  ACCEPTED = 'accepted',
  DELIVERED = 'delivered',
  OPENED = 'opened',
  CLICKED = 'clicked',
  UNSUBSCRIBED = 'unsubscribed',
  COMPLAINED = 'complained',
  FAILED = 'failed',
}
